<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content>

  <p>
    <mat-form-field
                    class="full-width">
        <mat-label>{{ 'client_user.email' | translate }}</mat-label>
          <input id="create_user_dialog.input_text.email"
                 matInput
                 [type]="'email'"
                 [(ngModel)]="email" >
    </mat-form-field>
  </p>

  <p>
    <mat-form-field
                    class="full-width">
        <mat-label>{{ 'client_user.user_code' | translate }}</mat-label>
          <input id="create_user_dialog.input_text.user_code"
                 matInput
                 [type]="'text'"
                 [(ngModel)]="userCode" >
    </mat-form-field>
  </p>
</div>

<div mat-dialog-actions align="center">

  <div class="col-sm-6 no-gutters pl-0">
    <button id="{{idPrefix}}btn.ok" mat-raised-button class="full-width" color="accent" [disabled]="!email || !userCode" *ngIf="data.confirmBtnOverride" (click)="accept()">{{ data.confirmBtnOverride | translate }}</button>
    <button id="{{idPrefix}}btn.ok" mat-raised-button class="full-width" color="accent" [disabled]="!email || !userCode" *ngIf="!data.confirmBtnOverride" (click)="accept()">{{ 'common.btn.yes' | translate }}</button>
  </div>

  <div class="col-sm-6 no-gutters pr-0">
    <button id="{{idPrefix}}btn.close" mat-raised-button class="full-width" *ngIf="data.closeBtnOverride" (click)="close()">{{ data.closeBtnOverride | translate }}</button>
    <button id="{{idPrefix}}btn.close" mat-raised-button class="full-width" *ngIf="!data.closeBtnOverride" (click)="close()">{{ 'common.btn.no' | translate }}</button>
  </div>

</div>
